import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { Logo } from '@/components/Logo';
import '@/styles/Header.css';
/**
 * Header component.
 *
 * This component represents the header of the application. It includes a button to toggle the sidebar
 * and the application logo.
 *
 * @param {HeaderProps} props - The props for the component.
 * @returns The Header component.
 */
const Header = ({ isSidebarOpen, toggleSidebar }) => {
    return (_jsxs("div", Object.assign({ className: "header" }, { children: [!isSidebarOpen && (_jsx("button", Object.assign({ className: "openbtn", onClick: toggleSidebar, title: "Open menu" }, { children: _jsx(MenuIcon, { style: { fontSize: '24px' } }) }))), _jsx(Logo, { onChatpage: true })] })));
};
export default Header;
